<template lang="pug">
  section
    b-container
      h1 REPORTS
      b-nav
        b-nav-item(:to="{name: 'ReportsRentals'}") RENTALS
    b-container.pt-2
      router-view
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/Reports.vue